import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { HiddenMessage } from "@sportal/cdk/hiddenMessage";

import { ListType } from "@sportal/api";

import { Button } from "../../../../../components/button/Button";
import { clearCsvFile } from "../../../urlFilters.actions";
import { useIntlTranslate } from "../../../../../hooks";

export const UploadSuccessButtons = ({ onAddUrls }) => {
  return (
    <Fragment>
      <Button color={"destructive"} onClick={() => onAddUrls(ListType.Block)}>
        <FormattedMessage id="block" />
      </Button>
      <Button onClick={() => onAddUrls(ListType.Allow)}>
        <FormattedMessage id="allow" />
      </Button>
    </Fragment>
  );
};

export const UploadFailButtons = ({ isEmptyCsv, onToggleAddMethod }) => {
  if (isEmptyCsv) {
    return <CancelButton />;
  }

  return (
    <Fragment>
      <CancelButton />
      <EnterManuallyButton onToggleAddMethod={onToggleAddMethod} />
    </Fragment>
  );
};

const CancelButton = () => {
  const dispatch = useDispatch();

  return (
    <Button color={"secondary"} onClick={() => dispatch(clearCsvFile())}>
      <FormattedMessage id="cancel" />
    </Button>
  );
};

export const EnterManuallyButton = ({ onToggleAddMethod }) => {
  const translate = useIntlTranslate();
  const id = "enter-manually-description";

  return (
    <Button
      color={"secondary"}
      onClick={onToggleAddMethod}
      aria-describedby={id}
    >
      <FormattedMessage id={"enter_manually"} />
      <HiddenMessage id={id} message={translate("aria_enter_urls_manually")} />
    </Button>
  );
};
